<template>
  <div class="GameSet">
    <div class="top">
      <div class="t_l">
        <span>关联游戏：</span>
        <a v-if="contentName">{{ contentName || '-' }}</a>
        <a v-else>无</a>
        <template v-if="editForm">
          <a-button v-permission="`Content.MatchSeting.SelectGame`" type="primary" @click="openGame()">选择游戏</a-button>
          <a-popconfirm title="是否移除当前匹配游戏?" ok-text="是" cancel-text="否" @confirm="clearGame" v-if="contentName">
            <em>移除</em>
          </a-popconfirm>
        </template>
      </div>
      <div class="t_r">
        <template v-if="editForm">
          <a-button style="margin-right: 8px" type="primary" @click="addLevel">新建匹配</a-button>
          <a-button style="margin-right: 8px" type="primary" @click="importLevel">导入匹配</a-button>
          <a-popconfirm v-permission="`Content.MatchSeting.DeleteAll`" title="是否清空当前所有设置?" ok-text="是" cancel-text="否" @confirm="clearSet">
            <a-button type="primary">重置设置</a-button>
          </a-popconfirm>
        </template>
      </div>
    </div>
    <div class="bottom tableForm" v-auth="`Content.MatchSeting.Save`">
      <a-form-model ref="tableForm" :model="tableForm" labelAlign="right">
        <a-table :locale="{}" :columns="columns" :data-source="tableForm.dataSource" :pagination="false" bordered size="middle">
          <div slot="minScore" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.minScore }}</span>
            <a-form-model-item v-else :prop="`dataSource[${index}].minScore`" label="" :rules="tableFormRules()">
              <a-input-number v-model="record.minScore" :precision="0" :min="50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="maxScore" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.maxScore }}</span>
            <a-form-model-item v-else label="" :prop="`dataSource[${index}].maxScore`" :rules="tableFormRules()">
              <a-input-number v-model="record.maxScore" :precision="0" :min="record.minScore || 50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="level" slot-scope="text, record">
            <a-select :disabled="!editForm" v-model="record.levelSign" :key="record.levelSign" :default-value="record.levelSign" placeholder="请选择关卡" style="width: 100%">
              <template v-for="item in levelList">
                <a-select-option v-if="item.levelName != '练习关'" :value="item.levelSign" :text="item.levelName" :key="item.id" @click="getRecord(item, record)">{{ item.levelName }}</a-select-option>
              </template>
            </a-select>
          </div>
          <div slot="action" slot-scope="text, record">
            <a href="#" v-if="editForm" style="color: #f00" @click="removeLevel(record)">删除</a>
          </div>
        </a-table>
      </a-form-model>

      <div class="subBox" v-permission="`Content.MatchSeting.Save`">
        <a-button v-if="editForm" type="primary" @click="submit()">保存</a-button>
        <a-button v-else type="primary" @click="edit()">编辑</a-button>
      </div>
    </div>
    <!-- 关联游戏 -->
    <a-modal v-model="pickGame" title="关联游戏" @ok="changGame" width="1000px">
      <a-form layout="inline" class="searchForm">
        <a-form-item label="游戏名称">
          <a-input allowClear placeholder="请输入游戏名称" v-model="gamesearch.Name" />
        </a-form-item>
        <a-form-item label="能力维度">
          <a-cascader
            style="width: 200px"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body
              }
            "
            v-model="gameCascaderValue"
            :options="options"
            :load-data="loadData"
            placeholder="请选择能力维度"
            change-on-select
            @change="onChange"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="getGameList(1)">查询</a-button>
          <a-button @click="searchGameReset" style="margin-left: 15px">重置</a-button>
        </a-form-item>
      </a-form>
      <a-table
        style="min-width: 800px; margin-top: 15px"
        :scroll="{ y: 350 }"
        rowKey="id"
        :row-selection="rowSelection"
        :columns="gameColums"
        :data-source="gamesData"
        :pagination="{
          current: gamesearch.pageIndex,
          pageSize: gamesearch.pageSize,
          total: gametotal,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: gamePageChange,
          onShowSizeChange: gameSizeChange,
        }"
      ></a-table>
    </a-modal>
    <AddLeveModal ref="AddLeveModalRef" :levelList="levelList" :dataList="this.tableForm.dataSource" />
    <ImportMdoal
      ref="ImportMdoalRef"
      :download-name="$route.query.name + '游戏匹配规则'"
      :template-url="`${$data._templatePath}/template/excel/matchSeting_template.xlsx`"
      title="导入匹配"
      :toJson="true"
    />
  </div>
</template>

<script>
import AddLeveModal from './addLeveModal'
import ImportMdoal from '@/components/ImportModal/index.vue'
import { saveMatchSetting, getMatchSetting } from '@/utils/http'
import defaultLevel from './defaultLevel'

const columns = [
  {
    title: '游戏原始分范围',
    align: 'center',
    children: [
      {
        title: '最低分',
        dataIndex: 'minScore',
        align: 'center',
        key: 'minScore',
        scopedSlots: { customRender: 'minScore' },
      },
      {
        title: '最高分',
        dataIndex: 'maxScore',
        align: 'center',
        key: 'maxScore',
        scopedSlots: { customRender: 'maxScore' },
      },
    ],
  },
  {
    title: '初始关卡设置',
    key: 'level',
    scopedSlots: { customRender: 'level' },
    align: 'center',
  },
  {
    title: '',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]
const gameColums = [
  { title: '游戏名称', dataIndex: 'name', key: 'name', align: 'center' },
  { title: '版本', dataIndex: 'versionName', key: 'versionName', align: 'center' },
  {
    title: '能力类型',
    dataIndex: 'abilityTypeName',
    key: 'abilityTypeName',
    align: 'center',
  },
  {
    title: '一级能力',
    dataIndex: 'firstAbilityName',
    key: 'firstAbilityName',
    align: 'center',
  },
  {
    title: '二级能力',
    dataIndex: 'secondAbilityName',
    key: 'secondAbilityName',
    align: 'center',
  },
]

const importColumn = {
  '测评原始分最高分数（50-150整数）': 'maxScore',
  '测评原始分最低分数（50-150整数）': 'minScore',
  '关卡（1-50整数）': 'levelSign',
}

const tableFormRules = () => [{ required: true, message: '请填写内容', trigger: 'blur' }]
export default {
  name: 'GameSet',
  components: { AddLeveModal, ImportMdoal },
  inject: ['setIsSave'],
  data() {
    return {
      editForm: false,
      columns,
      tableForm: {
        dataSource: [],
      },
      abilityEvaluationSysId: '',
      gameId: '',
      pageIndex: 1,
      pageSize: 10,
      levelList: [],
      contentName: '',
      detailList: [],
      gameCascaderValue: [],
      // 关联游戏
      gamesearch: {
        pageIndex: 1,
        pageSize: 10,
        contentType: 1,
        gameLevelMatchSettingId: this.gameId,
        Name: '',
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
      },
      gametotal: 0,
      pickGame: false,
      advanced: false,
      options: [],
      selectId: '',
      gameColums,
      gamesData: [],
      selectedRowKeys: [],
      gamsParams: {},
      selectedRowKeys: [], //选中的游戏
      queryList: [],
    }
  },
  created() {
    Promise.all([this.GetAbilityevaluationsys(), this.levelSelect(), this.abilityTypeSelect(0)]).then(() => {
      this.getMatchSettingInfo()
    })
  },
  computed: {
    rowSelection() {
      return {
        type: 'radio',
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this._cacheGame = {
            ContentId: +this.$route.query.id,
            RelatedContentAbilityId: +selectedRowKeys[0],
            SettingType: 1,
            Id: this.gameId || null,
            AbilityEvaluationSysId: this.abilityEvaluationSysId,
            contentName: selectedRows[0].name,
          }
        },
      }
    },
  },
  watch: {
    pickGame() {
      // this.getmatchinfo()
    },
  },
  methods: {
    getvalidScore(score, type = 'min') {
      if (type == 'min') {
        if (score <= 150 && score >= 50) {
          return score
        }
        return 50
      }
      if (type == 'max') {
        if (score <= 150 && score >= 50) {
          return score
        }
        return 150
      }
    },
    removeLevel(record) {
      this.tableForm.dataSource = this.tableForm.dataSource.filter((v) => v.id != record.id)
    },
    async importLevel() {
      const data = await this.$refs['ImportMdoalRef'].showModal()
      const keys = Object.keys(importColumn)
      const total = data.length
      const dataSource = []
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        const result = {}
        let error = false
        keys.forEach((key) => {
          const rkey = importColumn[key]
          const val = item[key]
          if (Object.prototype.toString.call(val).slice(8, -1) != 'Number') {
            error = true
          }
          result[rkey] = item[key]
        })
        if (result.levelSign > this.levelList.length || result.levelSign > 41) {
          error = true
        }
        if (result.maxScore > 150 || result.minScore < 50) {
          error = true
        }
        if (!error) {
          result.id = i + +new Date()
          dataSource.push(result)
        }
      }
      this.tableForm.dataSource = dataSource
      const errorLen = total - dataSource.length
      this.tableForm.dataSource = this.tableForm.dataSource.sort((a, b) => {
        return Number(a.maxScore) - Number(b.maxScore)
      })
      const msgType = errorLen ? 'error' : 'success'
      this.$message[msgType](`${errorLen ? '部分数据有误' : '全部导入成功'}：本次需导入数据${total}条，其中成功${dataSource.length}条，失败${errorLen}条`)
    },
    async addLevel() {
      const data = await this.$refs['AddLeveModalRef'].showMdoal()
      this.tableForm.dataSource.push(...data)
      this.tableForm.dataSource = this.tableForm.dataSource.sort((a, b) => {
        return Number(a.maxScore) - Number(b.maxScore)
      })
    },
    tableFormRules,
    repeatScoreValidator() {
      const tableSet = new Set()
      const setScore = (min, max) => {
        for (let i = min; i <= max; i++) {
          if (tableSet.has(i)) {
            return false
          } else {
            tableSet.add(i)
          }
        }
        return true
      }
      return this.tableForm.dataSource.some((item) => {
        const isRepeat = setScore(+item.minScore, +item.maxScore)
        return !isRepeat
      })
    },
    edit() {
      this.editForm = true
      this.setIsSave(false)
    },
    //获取能力体系ID
    GetAbilityevaluationsys() {
      return this.$http.ReportService.getAbilityEvaluationSys().then(res => {
        this.abilityEvaluationSysId = res.data[0].id
        return res
      })
    },
    initDefaultConfig() {
      const dataSource = []
      const len = defaultLevel.length
      for (let i = 0; i < Math.min(len, 41); i++) {
        const item = {
          ...defaultLevel[i],
          levelSign: i + 1,
          id: i,
        }
        dataSource.push(item)
      }
      this.tableForm.dataSource = dataSource
    },
    async getMatchSettingInfo() {
      const { data } = await getMatchSetting({
        contentId: this.$route.query.id,
        settingType: 1,
      })
        const { id, relatedContentAbilityId, settingDetails, contentName } = data.data || {}
        if (!settingDetails?.length) {
          this.initDefaultConfig()
        } else {
          this.tableForm.dataSource = settingDetails?.map((v, i) => ({
            levelSign: v.levelSign,
            minScore: v.minStandard,
            maxScore: v.maxStandard,
            id: i,
          }))
          console.log(settingDetails.length);
          if (settingDetails.length < 41) {
            const append = defaultLevel.slice(settingDetails.length).map((v, i) => ({
              ...v,
              levelSign: i + settingDetails.length + 1,
              id: +new Date() + i,
            }))
            console.log(append);
            this.tableForm.dataSource.push(...append)
          }
        }
        this._settingId = id
        let selectArr = []
        selectArr.push(relatedContentAbilityId)
        this.selectedRowKeys = selectArr
        this.contentName = contentName
    },
    // 基础信息
    getmatchinfo() {
      let params = {
        contentId: this.$route.query.id,
        settingType: 1,
      }
      this.$http.getmatchinfo(params).then((res) => {
        if ( res.data.data) {
          // 选中数据回显
          if (res.data.data.relatedContentAbilityId) {
            let selectArr = []
            selectArr.push(res.data.data.relatedContentAbilityId)
            this.selectedRowKeys = selectArr
            this.onSelectChange('', res.data.data.relatedContentAbilityId)
          } else {
            this.selectedRowKeys = []
          }

          this.contentName = res.data.data.contentName
          this.matchList()
          this.gameId = res.data.data.id
          this.gamesearch.gameLevelMatchSettingId = res.data.data.id
          this.detailList = res.data.data.detailList
          this.detailList.forEach((item) => {
            let str = {}
            str.abilityLevelConfigId = item.abilityLevelConfigId
            str.gameLevelMatchSettingDetailId = item.id
            str.levelSign = item.levelSign
            this.queryList.push(JSON.parse(JSON.stringify(str)))
            console.log(this.queryList, '===queryList')
          })
        } else {
          this.matchList()
        }
      })
    },
    // 获取能力等级
    matchList() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        abilityEvaluationSysId: this.abilityEvaluationSysId,
      }
      this.$http.matchList(params).then((res) => {
          if (this.levelList.length) {
            this.detailList.forEach((item) => {
              this.tableForm.dataSource.forEach((el) => {
                if (item.abilityLevelConfigId == el.id) {
                  el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                  el.levelId = item.id
                }
              })
            })
          } else {
            this.detailList.forEach((item) => {
              this.tableForm.dataSource.forEach((el) => {
                if (item.abilityLevelConfigId == el.id) {
                  el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                  el.levelId = item.id
                }
              })
            })
          }
      })
    },
    // 关联游戏
    openGame() {
      this.pickGame = true
      this.getGameList()
    },
    // 关联游戏列表
    getGameList(pageIndex) {
      if (pageIndex) {
        this.gamesearch.pageIndex = pageIndex
      }
      this.$http.matchGameList({ ...this.gamesearch }).then((res) => {
          this.gamesData = res.data.data.items
          this.gametotal = res.data.data.totalCount
      })
    },
    // 确定选择的关联游戏
    changGame() {
      this.$message.destroy()
      if (!this.selectedRowKeys.length) {
        this.$message.warn('请选择游戏')
        return
      }
      this.contentName = this._cacheGame?.contentName
      this.gamsParams = {
        ContentId: +this.$route.query.id,
        RelatedContentAbilityId: +this.selectedRowKeys[0],
        SettingType: 1,
        Id: this.gameId || null,
        AbilityEvaluationSysId: this.abilityEvaluationSysId,
      }
      return (this.pickGame = false)
    },
    // 关联游戏能力维度
    onChange(value) {
      this.gamesearch.AbilityTypeId = value[0]
      this.gamesearch.FirstAbilityId = value[1]
      this.gamesearch.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      targetOption.children = []
      let params = {
        pid: this.selectId[this.selectId.length - 1],
      }
      this.$http.abilitySelect(params).then((res) => {
          targetOption.loading = false
          res.data.data.forEach((item) => {
            let str = {}
            if (this.selectId.length < 2) {
              str = {
                value: item.id,
                label: item.name,
                isLeaf: false,
              }
            } else {
              str = {
                value: item.id,
                label: item.name,
              }
            }
            targetOption.children.push(JSON.parse(JSON.stringify(str)))
            this.options = [...this.options]
          })
      })
    },
    abilityTypeSelect(level) {
      return new Promise((resolve, reject) => {
        let params = {
          level: level,
        }
        this.$http.abilitySelect(params).then((res) => {
            this.options = res.data.data
            this.options.forEach((item) => {
              item.value = item.id
              item.label = item.name
              item.isLeaf = false
            })
            resolve()
          reject()
        })
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      let relatedContentAbilityId = null
      if (typeof selectedRows === 'number') {
        relatedContentAbilityId = selectedRows
      } else {
        relatedContentAbilityId = selectedRows[0].id
      }
      this.gamsParams = {
        ContentId: +this.$route.query.id,
        RelatedContentAbilityId: +relatedContentAbilityId,
        SettingType: 1,
        Id: this.gameId || null,
        AbilityEvaluationSysId: this.abilityEvaluationSysId,
      }
    },
    // 获取关卡
    levelSelect() {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('tainGameId', this.$route.query.id)
        this.$http.levelSelect(formData).then((res) => {
            this.levelList = res.data.data.filter((v) => v.levelName != '练习关').slice(0, 41)
            resolve()
          reject()
        })
      })
    },

    // 移除游戏
    clearGame() {
      this.selectedRowKeys = []
      this.gamsParams = {}
      this.contentName = ''
    },
    // 清空设置
    clearSet() {
      this.initDefaultConfig()
      this.clearGame()
    },
    async submitValidate() {
      this.$message.destroy()
      return new Promise((reslove, reject) => {
        if (!this.contentName) {
          this.$confirm({
            title: '未关联测评游戏',
            content: '未关联测评游戏，是否退出编辑？ 退出后游戏匹配规则不生效',
            onOk() {
              reslove()
            },
            onCancel() {
              reject()
            },
          })
        } else {
          reslove()
        }
      })
    },
    // 保存
    async submit() {
      this.$refs['tableForm'].validate(async (valid) => {
        if (!valid) return
        await this.submitValidate()
        if (this.repeatScoreValidator()) {
          return this.$message.error('分数范围重复')
        }
        let params = {
          id: this._settingId,
          contentId: this.$route.query.id,
          settingType: 1,
          relatedContentAbilityId: this.selectedRowKeys[0],
          useFirstAbility: true,
          multipleAbilitySocreProcessType: 0,
          status: true,
          settingDetails: this.tableForm.dataSource.map((v) => ({
            levelSign: v.levelSign,
            minStandard: v.minScore,
            maxStandard: v.maxScore,
          })),
        }
        const { data } = await saveMatchSetting(params)
          this.$message.success(data.message)
          this.editForm = false
          this.setIsSave(true)
       
      })
    },
    // 重置
    searchGameReset() {
      this.gameCascaderValue = []
      this.gamesearch.Name = ''
      this.gamesearch.AbilityTypeId = ''
      this.gamesearch.FirstAbilityId = ''
      this.gamesearch.pageIndex = 1
      this.gamesearch.pageSize = 10
      this.gamesearch.SecondAbilityId = ''
      this.getGameList()
    },
    getRecord(item, record) {
      record.levelSign = item ? item.levelSign : '-1'
    },
    changeLevel(GameLevelMatchSettingId) {
      let params = {
        AbilityEvaluationSysId: this.abilityEvaluationSysId,
        ContentId: +this.$route.query.id,
        GameLevelMatchSettingId: GameLevelMatchSettingId,
        SettingType: 1,
      }
      this.$http.updategameconfig(params).then((res) => {
          this.getmatchinfo()
          this.levelSelect()
    
      })
    },
    gamePageChange(pageIndex, size) {
      this.gamesearch.pageIndex = pageIndex
      this.getGameList()
    },
    gameSizeChange(pageIndex, size) {
      this.gamesearch.pageIndex = 1
      this.gamesearch.pageSize = size
      this.getGameList()
    },
  },
}
</script>

<style scoped>
/deep/ .searchForm {
  display: flex;
}

/deep/ .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.tableForm {
  ::v-deep .ant-form-item {
    margin-bottom: 0px;
  }
}
.top {
  display: flex;
  justify-content: space-between;
  .t_l {
    display: flex;
    align-items: center;
    span {
      color: #666666;
      font-weight: 600;
    }
    a {
      font-weight: 600;
    }
    .ant-btn-primary {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      margin-left: 20px;
    }
    em {
      color: #ff5722;
      font-size: 14px;
      font-style: normal;
      margin-left: 15px;
      cursor: pointer;
    }
  }
}

.bottom {
  margin-top: 15px;
}

.subBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 35px;
  background: #fff;
  padding:8px 0;
  width:calc(100% - 15% - 48px - 256px);
}
</style>
